import * as React from "react";
import Box from "@mui/material/Box";
import Banner from "./Banner";
import Features from "./Features";
import { Layout } from "../../../layouts";

/**
 * Home component - Landing page for the application
 * @return {JSX.Element} Home component
 */
function Home() {
  return (
    <Layout>
      <Banner />
      <Box
        sx={{
          flex: "1",
        }}
      >
        <Features />
      </Box>
    </Layout>
  );
}

export default Home;
